export default __webpack_public_path__ + "static/media/fast.f1644b7d.png";